import React, { useEffect, useState } from 'react';
import './meetPersonalAssistantSection.scss';
import TagCloud from "./components/TagCloud";
import { scrollToBlock } from "../../../../components/utils/utilsFunc";

const MeetPersonalAssistantSection = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	return (
		<div className="meetPersonalAssistant">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="meetPersonalAssistant__content">
				<div className="meetPersonalAssistant__content_data">
					<h2>Meet your personal assistant</h2>
					{
						width < 1024 ? (
							<TagCloud />
						) : null
					}
					{
						width < 1024 ? (
							<div className="meetPersonalAssistant__content_data_over">
								<h4>Over 150+ project</h4>
								<span>reviews performed on our platform today</span>
							</div>
						) : null
					}
					<p>
						NFD Platform will save you time and help you earn money easier
					</p>
					<div className="meetPersonalAssistant__content_data_buttons">
						<button
							className="secondButton"
							onClick={() => window.open('https://app.nfd.gg/')}
						>
							<span>Go To Platform</span>
						</button>
						<button
							className="mainButton"
							onClick={() => scrollToBlock('platformProjects')}
						>
							<span>Learn more</span>
						</button>
					</div>
				</div>
				{
					width > 1023 ? (
						<TagCloud />
					) : null
				}
				{
					width > 1023 ? (
						<div className="meetPersonalAssistant__content_over">
							<h4>Over 150+ project</h4>
							<span>reviews performed on our platform today</span>
						</div>
					) : null
				}
			</div>
		</div>
	);
};

export default MeetPersonalAssistantSection;